import {getDatetimeAMPMinUTC} from 'utils/common';

export const getFormattedGoogleSitesListDate = (date: string) => {
  return getDatetimeAMPMinUTC(date);
};
